import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { trackLocationSet, surfaceForPath, LOCATION_SOURCE_METHOD } from "../utils/analytics";

/**
 * Sends location_set once each time the shopper's delivery area actually
 * changes (GPS, a searched area, a confirmed suggestion), from wherever it was
 * set. One watcher in App instead of a call in every place that can set it.
 * A location restored from storage on page load is not counted.
 */
export default function useLocationSetTracking() {
  const latitude = useSelector((state) => state.userLocation?.latitude);
  const longitude = useSelector((state) => state.userLocation?.longitude);
  const source = useSelector((state) => state.userLocation?.locationSource);
  const previousKey = useRef(`${latitude},${longitude}`);

  useEffect(() => {
    const key = `${latitude},${longitude}`;
    if (key === previousKey.current) return;
    previousKey.current = key;
    if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) return;
    trackLocationSet(
      surfaceForPath(typeof window !== "undefined" ? window.location.pathname : ""),
      LOCATION_SOURCE_METHOD[source] || source || "unknown"
    );
  }, [latitude, longitude, source]);
}
